<ng-container *ngIf="events$ | async as events">
  <mb-section-headline [headline]="'EVENTS' | translate" [anchor]="'EVENTS' | translate"></mb-section-headline>
  <mb-ribbon-slider-section
    containerClass="container-sm"
    [items]="events"
    [filters]="filters"
    [mobileFilter]="true"
    [itemWrapperClasses]="['col-11', 'col-xs-5', 'col-sm-7', 'col-md-5', 'col-xl-4']"
    [offsetItemClasses]="['d-none', 'd-sm-block', 'col-sm-1']"
    (filtered)="filtered($event)"
  >
    <ng-template #itemTemplate let-item="item" let-index="index">
      <mb-event-ribbon-card [event]="item" [index]="index + 1" [total]="events.length"></mb-event-ribbon-card>
    </ng-template>
  </mb-ribbon-slider-section>
</ng-container>
